import React from 'react';

import { Badge } from '@mui/material';

import { ReactComponent as FilterIcon } from '../../../../assets/icons/filter.svg';
import AppIconPillButton from '../../buttons/app-icon-pill-button/AppIconPillButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

interface IFilterActionButtonProps extends IBaseActionButtonProps {
  selectedCount?: number;
}

const FilterActionButton = (props: IFilterActionButtonProps) => {
  const { selectedCount = 0, ...baseProps } = props;
  const { classes } = useStyles();

  return (
    <Badge
      overlap="circular"
      badgeContent={selectedCount}
      invisible={selectedCount <= 0}
      classes={{ badge: classes.badge }}>
      <AppIconPillButton colorVariant="secondary" {...baseProps}>
        <FilterIcon className={classes.icon} />
      </AppIconPillButton>
    </Badge>
  );
};

export default FilterActionButton;
